import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl197ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup.date().required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocPraktDS: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    usageFromDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .max(
        new Date("2016-07-07"),
        t("Η ημερομηνία πρέπει να είναι πριν από τις 07/07/2016")
      )
      .test(
        "date",
        t("Η ημερομηνία πρέπει να είναι πριν από την ημερομηνία εώς χρήση"),
        function (value: Date | null, context) {
          const { usageToDate } = context.parent;
          return value ? value < usageToDate : false;
        }
      ),
    usageToDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .max(
        new Date("2016-07-07"),
        t("Η ημερομηνία πρέπει να είναι πριν από τις 07/07/2016")
      )
      .test(
        "date",
        t("Η ημερομηνία πρέπει να είναι μετά την ημερομηνία από χρήση"),
        function (value: Date | null, context) {
          const { usageFromDate } = context.parent;
          return value ? value > usageFromDate : false;
        }
      ),
  });
};
